<template>
    <b-img @click="$emit('click')" class="riskhub-logo" :src="require('@/assets/images/logo.svg')"></b-img>
</template>

<script>
export default {
  name: 'Riskhub-Logo',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.riskhub-logo {
    height: 50px;
    width: 50px;
    margin-left: 2.2em;
    margin-top: 0.5em;
}
</style>
